<template>
  <sb-modal
    :active="isVisible"
    :escape-trigger="false"
    :click-outside-trigger="false"
    class="switch-homecountry-modal"
    :loading-promise="getAllCountryCurrencyData"
    @close="onClose"
  >
    <SbLoadingPromiseWrapper v-if="confirmDialog" :loading-promise="saveHomeCountryLoading">
      <div>
        <section class="modal-header">
          <h2 class="modal-title">
            Confirm Home Country
          </h2>
          <div class="modal-sub-title">
            The currency on the dashboard will reflect the home country you have selected
          </div>
        </section>
        <section class="modal-body">
          <div class="modal-body-header">
            Are you sure you want to change home country?
          </div>
          <div class="country-currency-info">
            <country-flag :country="homeCountryData.countryISO2" />
            {{ getCurrentCountryText }}
            <img src="@assets/images/point-right.svg" alt="to" style="margin:0px 12px 3px 12px;">
            <country-flag :country="selectedCountryData.countryISO2" />
            {{ getNewCountryText }}
          </div>
        </section>
        <section class="action">
          <div class="switch-home-warning">
            <img src="@assets/images/info.svg" alt="info" style="margin:0 0 3px 2px;">
            {{ enableDeletePaymentMethodsForCountrySwitch && !isCountrySwitchingToCanada
              ? "Changing the home country locks the currency and removes payment methods, temporarily putting orders on hold. After the switch, re-add payment methods promptly to resume orders."
              : "When you change the home country, it is locked and can't be reversed." }}
          </div>
          <div class="actions">
            <sb-button variation="primary" class="btn-confirm" @click.prevent="handleHomeCountrySwitch">
              Yes, Change Home Country
            </sb-button>
            <sb-button variation="tertiary" class="btn-cancel" @click.prevent="onClose">
              No, Don’t Change
            </sb-button>
          </div>
        </section>
      </div>
    </SbLoadingPromiseWrapper>
    <SbLoadingPromiseWrapper v-else :loading-promise="saveHomeCountryLoading">
      <div>
        <section class="modal-header">
          <div class="header-icon">
            <img src="@assets/images/circle.svg" alt="to" class="bg-circle">
            <img src="@assets/images/check-mark.svg" alt="to" style="margin:40px 12px 3px;">
          </div>
        </section>
        <section class="modal-body">
          <h1 class="country-section">
            {{ selectedCountryData.name }}
            is now your home country
          </h1>
          <h2 class="currency-section">
            Currency : {{ getCurrencyText }}
          </h2>
        </section>
        <section class="action">
          <div v-if="warningMessage" class="switch-home-warning">
            <img src="@assets/images/info.svg" alt="info" style="margin:0 0 3px 2px;">
            {{ warningMessage }}
          </div>
          <div class="actions">
            <sb-button variation="primary" class="btn-got-it" @click.prevent="onClose">
              Ok, Got It
            </sb-button>
          </div>
        </section>
      </div>
    </SbLoadingPromiseWrapper>
  </sb-modal>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import CountryEnum from '@/enums/modules/payment/countryEnum'

export default {
  name: 'SwitchHomeCountryModal',
  components: {
    CountryFlag
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: true
    },
    selectedRow: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    confirmDialog: true,
    allCountriesData: [[]],
    homeCountryData: {
      countryISO2: ''
    },
    selectedCountryData: {
      countryISO2: ''
    },
    warningMessage: ''
  }),
  computed: {
    getAllCountryCurrencyData () {
      return this.$shipBobStore.getters.loading('getAllCountryCurrencyData')
    },
    saveHomeCountryLoading () {
      return this.$shipBobStore.getters.loading('saveHomeCountry')
    },
    getCurrentCountryText () {
      const homeCountry = this.$shipBobStore.getters['pricing/userHomeCountry']
      return this.getCountryText(homeCountry.countryCode)
    },
    getNewCountryText () {
      return this.getCountryText(this.selectedRow?.Country.Id)
    },
    getCurrencyText () {
      return this.selectedCountryData?.currencyName ? `${this.selectedCountryData.currencyName} (${this.selectedCountryData.currencySymbol}${this.selectedCountryData.currencyCode})` : ''
    },
    enableDeletePaymentMethodsForCountrySwitch () {
      return this.$shipBobStore.getters.enableDeletePaymentMethodsForCountrySwitch
    },
    isCountrySwitchingToCanada () {
      return this.selectedRow?.Country.Id === CountryEnum.CA
    }
  },
  async created () {
    this.allCountriesData = await this.$shipBobStore.getters.loading('getAllCountryCurrencyData')
    const homeCountry = this.$shipBobStore.getters['pricing/userHomeCountry']
    this.selectedCountryData = this.allCountriesData[0]?.find(country => country.countryISO2 === this.selectedRow?.Country.Id)
    this.homeCountryData = this.allCountriesData[0]?.find(country => country.countryISO2 === homeCountry.countryCode)
  },
  methods: {
    getCountryText (countryCode) {
      const currentCountry = this.allCountriesData[0]?.find(country => country.countryISO2 === countryCode)
      return currentCountry ? `${currentCountry.name} (${currentCountry.currencySymbol}${currentCountry.currencyCode})` : ''
    },
    async handleHomeCountrySwitch () {
      this.$emit('handleSwitchHomeCountry', this.selectedCountryData.countryISO2)
      const res = await this.$shipBobStore.getters.loading('saveHomeCountry')
      const isSuccess = res[0]?.isSuccess === true || res[0] === true
      const warningMessage = res[0]?.message
      if (isSuccess) {
        await this.$shipBobStore.dispatch('admin/refreshUserHomeCountry')
        await this.$shipBobStore.dispatch('admin/getAllAssignablePlans')
        this.confirmDialog = false
        if (warningMessage) {
          this.warningMessage = warningMessage
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-header {
    display: block;
    text-align: center;
}
.modal-title {
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #3A4B5E;
}
.modal-sub-title{
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #696969;
}
.modal-body {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
}
.country-currency-info {
    margin-top: 6px;
}
.switch-home-warning {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 13px 15px 13px 14px;
    gap: 10px;
    background: #FCF8E3;
    border-radius: 5px;
    width: 18rem;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #8A6D3B;
    flex: none;
    text-align: left;
}
.flag{
  // border-radius: 50%;
  clip-path: circle();
  transform: scale(0.44) !important;
  margin: 0 -1.2em 0.17em -0.7em !important;
  vertical-align: middle;
}

.action {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
}
.actions {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 5px;
    button {
        margin: 5px;
        text-align: center;
        width: 18rem;
        padding: 8px;
        border-radius: 5px;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
    }
    button.btn-confirm {
        background: #2470AF;
        border-bottom: 2px solid #195685;
        color: #FFFFFF;
    }
    button.btn-cancel {
        background: #FFFFFF;
        border: 1px solid #2570AF;
        color: #2570AF;
    }
    button.btn-got-it {
      width: 12rem;
      background: #2470AF;
      border-bottom: 2px solid #195685;
    }
}
.bg-circle {
  position: absolute;
  margin-left: -22px;
}

h1.country-section {
  font-weight: 600;
  font-size: 30px;
  line-height: 37px;
  text-align: center;
  color: #343E4F;
}
h2.currency-section {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}
</style>
